import { render, staticRenderFns } from "./PulpitNieodebrane.vue?vue&type=template&id=28e5f533&scoped=true&"
import script from "./PulpitNieodebrane.vue?vue&type=script&lang=js&"
export * from "./PulpitNieodebrane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5f533",
  null
  
)

export default component.exports